import { createBrowserHistory } from 'history'
import { loadingBarMiddleware } from 'react-redux-loading-bar'
import { applyMiddleware, createStore, compose } from 'redux'
import { routerMiddleware } from 'connected-react-router'
import axiosMiddleware from 'redux-axios-middleware'
import thunk from 'redux-thunk'

import AxiosConfig from '../shared/infra/http/AxiosConfig'
import rootReducer from './root.reducer'

export const history = createBrowserHistory()

export default function configureStore(initialState) {
  return createStore(
    rootReducer(history),
    initialState,
    compose(
      applyMiddleware(
        routerMiddleware(history),
        thunk,
        axiosMiddleware(AxiosConfig.AxiosClient, AxiosConfig.MiddlewareConfig),
        loadingBarMiddleware({
          promiseTypeSuffixes: ['REQUEST', 'SUCCESS', 'FAIL']
        })
      )
    )
  )
}
